import { render, staticRenderFns } from "./AiRecommendDiseaseButton.vue?vue&type=template&id=39a9926e&"
import script from "./AiRecommendDiseaseButton.vue?vue&type=script&lang=ts&"
export * from "./AiRecommendDiseaseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports